/**
 * Respuestas 403 del API por alcance o reglas de acceso (`code` en el cuerpo): las muestra con el texto del
 * idioma de la persona. Devuelve null si el error no es de esos.
 */
import { TextKey, currentLang, translate } from '../i18n';

const ACCESS_CODES = ['OUT_OF_SCOPE', 'ONLY_TODAY', 'ROLE_OUT_OF_SCOPE', 'SELF_ASSIGNMENT', 'SYSTEM_USER_PROTECTED', 'OWN_ROLE'] as const;

export const accessErrorMessage = (error: unknown): string | null => {
  const code = (error as any)?.response?.data?.code;
  if (!(ACCESS_CODES as readonly string[]).includes(code)) return null;
  return translate(currentLang(), `common.accessError.${code}` as TextKey);
};
